import { useSelector, useDispatch } from "react-redux";
import React, { useState, useEffect } from "react";
import Icon from "@mdi/react";
import {
    mdiNote,
} from "@mdi/js";
import { pushNotification } from "utils/notifications";
import Pagination from "react-js-pagination";
import moment from "moment";
import NumberFormat from "react-number-format";
import { getBranch } from "utils/utils";
import {
    getListDanhSachDonHang,
    updateDataSearch,
} from "../../../actions/DanhSachDonHang";
import ChiNhanhApi from "service/DanhMucService/ChiNhanhApi";
import { getUserLogin } from "utils/utils";
import { BtnChiTiet } from "./ChucNang/ChiTiet/BtnChiTiet";
import { Index_GetAllRoleInUser } from "actions/User";
import configs from "../../../constants/configs";
import { LamTronNghin } from "utils/utils";
import { Cookies } from "react-cookie";
import { BtnChiTietDonHang } from "./ChucNang/ChiTiet/BtnChiTietDonHang";

export const TableDanhSach = ({
    configLenhSanXuat,
    isConfigMaPO,
    isConfigThongTinLSX,
    isLamTronTien,
    roleEditDH,
    isEditDHCheckTrangThaiKho,
    isCheckInNhanh,
    setIsCheckInNhanh,
    roleXoaDH,
    roleDuyetYeuCau,
    roleEditDHQuaNgay,
}) => {
    document.title = "Đại Lý - Danh sách đơn đặt hàng";
    const dispatch = useDispatch();
    const listDonHang = useSelector((state) => state.listDanhSachDonHang);
    const dataSearch = useSelector((state) => state.dataSearchDanhSachDonHang);

    const [lstChiNhanh, setLstChiNhanh] = useState([]);

    useEffect(() => {
        //Gọi phân quyền
        dispatch(Index_GetAllRoleInUser({ username: getUserLogin().UserName }));
        //
        ChiNhanhApi.listChiNhanh(getUserLogin().UserName).then((response) => {
            if (response.data.List.length > 0) {
                var lst = response.data.List.filter((x) => x.BranchID !== 0);
                if (typeof lst !== "undefined") {
                    setLstChiNhanh(lst);
                }
            }
        });

        if (getBranch() == 0 || getBranch() == "0") {
            ChiNhanhApi.listChiNhanh(getUserLogin().UserName).then((response) => {
                if (response.data.List.length > 0) {
                    var lst = response.data.List.filter((x) => x.BranchID !== 0);
                    const reducedArray = lst.reduce(
                        (acc, curr) => `${acc}${curr.BranchID}_`,
                        ""
                    ); //chuyển list array sang dạng string chỉ lấy nhánh id
                    const stringNew = reducedArray.slice(0, -1);
                    const searchNew = {
                        fromDate: dataSearch.fromDate,
                        toDate: dataSearch.toDate,
                        typeDate: dataSearch.typeDate,
                        sSearch: dataSearch.sSearch,
                        sUserName: dataSearch.sUserName,
                        sCustomerName: dataSearch.sCustomerName,
                        iTrangThaiTruKho: dataSearch.iTrangThaiTruKho,
                        iTrangThaiThanhToan: dataSearch.iTrangThaiThanhToan,
                        iBranch: dataSearch.iBranch,
                        sBranch: stringNew,
                        sNVKDUserName: dataSearch.sNVKDUserName,
                        lstNhomKH: dataSearch.lstNhomKH,
                        iLoaiDon: dataSearch.iLoaiDon,
                        iLoaiDoiTac: dataSearch.iLoaiDoiTac,
                        iPageIndex: dataSearch.iPageIndex,
                        iPageSize: dataSearch.iPageSize,
                    };
                    let params = new URLSearchParams(window.location.search);
                    let search = params.get("search");
                    let loai = params.get("loai");
                    let customerID = params.get("customerID");
                    if (loai === "macode" && search != "") {
                        searchNew.sSearch = search;
                    } else if (loai === "khachhang" && search != "") {
                        searchNew.sCustomerName = search;
                        if (customerID > 0) {
                            searchNew.fromDate = moment()
                                .startOf("year")
                                .format("YYYY-MM-DD");
                            searchNew.toDate = moment().endOf("year").format("YYYY-MM-DD");
                        }
                    }
                    dispatch(getListDanhSachDonHang(searchNew));
                    dispatch(updateDataSearch(searchNew));
                }
            });
        } else {
            let params = new URLSearchParams(window.location.search);
            let search = params.get("search");
            let loai = params.get("loai");
            let customerID = params.get("customerID");
            if (loai === "macode" && search != "") {
                dataSearch.sSearch = search;
            } else if (loai === "khachhang" && search != "") {
                dataSearch.sCustomerName = search;
                if (customerID > 0) {
                    dataSearch.fromDate = moment().startOf("year").format("YYYY-MM-DD");
                    dataSearch.toDate = moment().endOf("year").format("YYYY-MM-DD");
                }
            }
            dispatch(getListDanhSachDonHang(dataSearch));
            dispatch(updateDataSearch(dataSearch));
        }
    }, []);

    const onChangeCheckBranch = (index) => (e) => {
        const cate = { ...listDonHang };
        var strBranch = "";
        // Set lai gia tri khi click
        cate.List2.map((row, i) => {
            if (index === i) {
                if (e.target.checked === true) {
                    row.IsCheck = 1;
                    strBranch = strBranch + "_" + row.BranchID;
                } else {
                    row.IsCheck = 0;
                }
            } else {
                if (row.IsCheck) {
                    strBranch = strBranch + "_" + row.BranchID;
                }
            }
        });

        const searchNew = {
            fromDate: dataSearch.fromDate,
            toDate: dataSearch.toDate,
            typeDate: dataSearch.typeDate,
            sSearch: dataSearch.sSearch,
            sUserName: dataSearch.sUserName,
            sCustomerName: dataSearch.sCustomerName,
            iTrangThaiTruKho: dataSearch.iTrangThaiTruKho,
            iTrangThaiThanhToan: dataSearch.iTrangThaiThanhToan,
            iBranch: dataSearch.iBranch,
            sBranch: strBranch,
            sNVKDUserName: dataSearch.sNVKDUserName,
            lstNhomKH: dataSearch.lstNhomKH,
            iLoaiDon: dataSearch.iLoaiDon,
            iLoaiDoiTac: dataSearch.iLoaiDoiTac,
            iPageIndex: dataSearch.iPageIndex,
            iPageSize: dataSearch.iPageSize,
        };
        dispatch(getListDanhSachDonHang(searchNew));
    };

    const danhmuc = useSelector((state) => state.danhmuc);
    const { objConfigAll } = danhmuc;

    const [lamTron, setLamTron] = useState(true);
    if (objConfigAll.List.length > 0 && lamTron === null) {
        const configKhongLamTron = objConfigAll.List.find(
            (e) =>
                e.KeyID.toUpperCase() === configs.sKey.Khonglamtrontien.toUpperCase()
        );
        setLamTron(true);
        if (
            typeof configNVKD !== "undefined" &&
            configKhongLamTron != null &&
            configKhongLamTron.Value
        ) {
            if (configKhongLamTron.Value === "1") {
                setLamTron(false);
            }
        }
    }

    const [configMauHoaDon, setConfigMauHoaDon] = useState(" ");
    if (objConfigAll.List.length > 0 && configMauHoaDon == " ") {
        //
        var sconfigMauHoaDonPrint = objConfigAll.List.find(
            (e) => e.KeyID.toUpperCase() === configs.sKey.MauHoaDonPrint.toUpperCase()
        );
        if (
            typeof sconfigMauHoaDonPrint !== "undefined" &&
            sconfigMauHoaDonPrint != null &&
            sconfigMauHoaDonPrint.Value
        ) {
            setConfigMauHoaDon(sconfigMauHoaDonPrint.Value);
        }
        //
    }



    const loadPage = () => {
        getListDanhSachDonHang(dataSearch);
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }; // set lên đầu page ví dụ khi phân trang

    const handlePageChange = (pageNumber) => {
        if (getBranch() == 0 || getBranch() == "0") {
            console.log(pageNumber, "pageNumberpageNumber");
            console.log(getBranch(), "getBranch()getBranch()getBranch()");
            const cate = { ...listDonHang };
            var strBranch = "";
            // Set lai gia tri khi click
            cate.List2.map((row, i) => {
                if (row.IsCheck === 1) {
                    strBranch = strBranch + "_" + row.BranchID;
                }
            });
            dataSearch.iPageIndex = pageNumber;
            const searchNew = {
                fromDate: dataSearch.fromDate,
                toDate: dataSearch.toDate,
                typeDate: dataSearch.typeDate,
                sSearch: dataSearch.sSearch,
                sUserName: dataSearch.sUserName,
                sCustomerName: dataSearch.sCustomerName,
                iTrangThaiTruKho: dataSearch.iTrangThaiTruKho,
                iTrangThaiThanhToan: dataSearch.iTrangThaiThanhToan,
                iBranch: dataSearch.iBranch,
                sBranch: strBranch,
                sNVKDUserName: dataSearch.sNVKDUserName,
                lstNhomKH: dataSearch.lstNhomKH,
                iLoaiDon: dataSearch.iLoaiDon,
                iLoaiDoiTac: dataSearch.iLoaiDoiTac,
                iPageIndex: pageNumber,
                iPageSize: dataSearch.iPageSize,
            };
            dispatch(getListDanhSachDonHang(searchNew));
            loadPage(searchNew);
        } else {
            dataSearch.iPageIndex = pageNumber;
            dispatch(
                updateDataSearch({
                    ...dataSearch,
                    iPageIndex: pageNumber,
                })
            );
            dispatch(getListDanhSachDonHang(dataSearch));
            loadPage(dataSearch);
        }


    };
    //back trở lại giữ nguyên search
    const setFilterCookie = () => {
        let cookie =
            "fromDate::" +
            moment(dataSearch.fromDate).format("YYYY-MM-DD") +
            "&toDate::" +
            moment(dataSearch.toDate).format("YYYY-MM-DD") +
            "&typeDate::" +
            dataSearch.typeDate +
            "&sSearch::" +
            dataSearch.sSearch +
            "&sUserName::" +
            dataSearch.sUserName +
            "&sCustomerName::" +
            dataSearch.sCustomerName +
            "&iTrangThaiTruKho::" +
            dataSearch.iTrangThaiTruKho +
            "&iTrangThaiThanhToan::" +
            dataSearch.iTrangThaiThanhToan +
            "&iBranch::" +
            dataSearch.iBranch +
            "&sBranch::" +
            dataSearch.sBranch +
            "&sNVKDUserName::" +
            dataSearch.sNVKDUserName +
            "&lstNhomKH::" +
            dataSearch.lstNhomKH +
            "&iLoaiDon::" +
            dataSearch.iLoaiDon +
            "&iLoaiDoiTac::" +
            dataSearch.iLoaiDoiTac +
            "&iPageIndex::" +
            dataSearch.iPageIndex;
        const cookies = new Cookies();
        cookies.set("FilterDanhSachDonHangDaiLY", cookie, { path: "/" });
    };

    const ViewDonDatHang = (orderDatHangID) => {
        let url = "/PrintsFile/rpDatHangDaiLy?DatHangID=" + orderDatHangID;
        window.open(url, "_blank");
    }

    const ViewDonHang = (orderId) => {
        let url = "/PrintsFile/rpDonHang?OrderID=" + orderId;
        window.open(url, "_blank");
    }

    const renderTableData = () => {
        if (typeof listDonHang.List != "undefined" && listDonHang.iTotal !== 0) {
            return listDonHang.List.map((item, index) => {
                //
                var isSuaDonNew = true;
                var isXoaDonNew = true;
                if (item.IsTraHang === 1) {
                    isXoaDonNew = false;
                }
                if (item.IsXoaDon === 0) {
                    isXoaDonNew = false;
                }
                return (
                    <tr key={"trahang" + index}>
                        <td class="text-center-main">{item.RowNum}</td>
                        <td className="text-left-main">
                            <a
                                href={() => false}
                                class="iconTable-Main iconW18"
                                onClick={(e) => {
                                    e.preventDefault();
                                    ViewDonHang(item.OrderID);
                                }}
                            >
                                {item.OrderCode}
                            </a>
                            {!(item.Note === "" || item.Note === "undifined") && (
                                <>
                                    {"  "}
                                    <Icon
                                        path={mdiNote}
                                        title={item.Note}
                                        color="rgb(2, 73, 155)"
                                        size={1}
                                    />
                                </>
                            )}
                        </td>
                        <td class="text-left-main">
                            <a
                                href={() => false}
                                class="iconTable-Main iconW18"
                                onClick={(e) => {
                                    e.preventDefault();
                                    ViewDonDatHang(item.OrderDatHangID);
                                }}
                            >
                                {item.OrderDatHangCode}
                            </a>
                        </td>

                        <td class="text-center-main">
                            {moment(item.NgayTao).format("DD/MM/YYYY HH:mm:ss")}
                        </td>
                        <td class="text-right-main">
                            <NumberFormat
                                displayType={"text"}
                                value={item.TongTien}
                                thousandSeparator={true}
                            />
                        </td>
                        <td class="text-right-main">
                            <NumberFormat
                                displayType={"text"}
                                value={item.DaThanhToan}
                                thousandSeparator={true}
                            />
                        </td>
                        <td class="text-right-main">
                            <NumberFormat
                                displayType={"text"}
                                value={item.TienConlai}
                                thousandSeparator={true}
                            />
                        </td>
                        <td class="text-center-main">
                            {item.TenTrangThai}
                        </td>
                    </tr>
                );
            });
        } else {
            return (
                <tr>
                    <td colSpan="15">Không có dữ liệu</td>
                </tr>
            );
        }
    };

    return (
        <>
            <div class="table-mainNew">
                <div class="form-money-2">
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="text-money-new">
                                Tổng giá trị:
                                <span class="text-color-money">
                                    <NumberFormat
                                        displayType={"text"}
                                        value={listDonHang.TotalValue1}
                                        thousandSeparator={true}
                                    />{" "}
                                    đ
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="table-Main-content">
                    <table class="table table-hover-main">
                        <thead>
                            <tr>
                                <td class="text-center-main">STT</td>
                                <td class="text-left-main">Mã đơn hàng</td>
                                <td class="text-left-main">Mã đơn đặt hàng</td>
                                <td class="text-center-main">Thời gian lên đơn</td>
                                <td class="text-right-main">Thành tiền đơn hàng</td>
                                <td class="text-right-main">Đã thanh toán</td>
                                <td class="text-right-main">Còn lại</td>
                                <td class="text-center-main">Trạng thái</td>
                            </tr>
                        </thead>
                        <tbody>{renderTableData()}</tbody>
                    </table>
                </div>
            </div>
            <div class="paggination-ver2 text-center pagination-Main  justify-content-center ">
                {listDonHang.iTotal > 0 && (
                    <>
                        <div className="total-page">
                            Tổng số {listDonHang.iTotal} bản ghi
                        </div>
                        <Pagination
                            activePage={dataSearch.iPageIndex}
                            itemsCountPerPage={dataSearch.iPageSize}
                            totalItemsCount={listDonHang.iTotal}
                            pageRangeDisplayed={10}
                            onChange={handlePageChange}
                            hideNavigation={true}
                            itemClass="cssPage-item"
                            linkClass="cssPageLink"
                            activeClass="cssActiveClass"
                        />
                    </>
                )}
            </div>
        </>
    );
};
